import { dispatchEventBus } from "@catchoftheday/state";

export const TRIGGER_ONEPASS_UPSELL_MODAL_EVENT = {
  type: "@global/TRIGGER_ONEPASS_UPSELL_MODAL",
};

export const triggerOnePassUpsellModal = () => {
  dispatchEventBus({
    type: TRIGGER_ONEPASS_UPSELL_MODAL_EVENT.type,
  });
};
